import { browserType } from "../constants/string"

export const detectBrowserType = () => {
  let userAgent = navigator.userAgent;

  if(userAgent.match(/edg/i)) {
    return browserType.EDGE;
  } else if(userAgent.match(/chrome|chromium|crios/i)){
    return browserType.CHROME;
  }else if(userAgent.match(/firefox|fxios/i)){
    return browserType.FIREFOX;
  }  else if(userAgent.match(/safari/i)){
    return browserType.SAFARI;
  }else if(userAgent.match(/opr\//i)){
    return browserType.OPERA;
  } else{
    return browserType.UNKNOWN;
  }
}
